export default __webpack_public_path__ + "static/media/error.94d7b9aa.png";